import type { ImageContent } from '@mawkaa/types';
import { ImageIcon } from 'lucide-react';
import { cn } from '@mawkaa/ui';

interface ImageBlockProps {
  content: ImageContent;
  isEditing?: boolean;
}

export function ImageBlock({ content, isEditing }: ImageBlockProps) {
  const { src, alt, caption, link, aspectRatio = 'auto' } = content;

  const aspectClasses = {
    auto: '',
    '1:1': 'aspect-square',
    '4:3': 'aspect-[4/3]',
    '16:9': 'aspect-video',
    '21:9': 'aspect-[21/9]',
  };

  const ImageWrapper = link && !isEditing ? 'a' : 'div';

  if (!src) {
    return (
      <section className="px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className={cn(
            'bg-gray-100 rounded-lg flex items-center justify-center',
            aspectClasses[aspectRatio] || 'min-h-[200px]'
          )}>
            <div className="text-center text-muted-foreground">
              <ImageIcon className="w-12 h-12 mx-auto mb-2" />
              <p>Cliquez pour ajouter une image</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-8">
      <figure className="max-w-4xl mx-auto">
        <ImageWrapper
          {...(link && !isEditing ? { href: link, target: '_blank', rel: 'noopener noreferrer' } : {})}
        >
          <img
            src={src}
            alt={alt}
            className={cn(
              'w-full rounded-lg object-cover',
              aspectClasses[aspectRatio]
            )}
          />
        </ImageWrapper>
        {caption && (
          <figcaption className="text-center text-sm text-muted-foreground mt-2">
            {caption}
          </figcaption>
        )}
      </figure>
    </section>
  );
}
